import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/hooks/useAuth";
import useGetProfile from "../hooks/useGetProfile";
import ProfilePhotoNudgePrompt from "./ProfilePhotoNudgePrompt";
import {
  isProfilePhotoNudgeEligible,
  recordProfilePhotoNudgeShown,
} from "../utils/profilePhotoNudgeStorage";

const TOUCHPOINT = "first_login";

/**
 * Shows the profile-photo nudge once per eligibility window on the first
 * authenticated render of the app shell, for users still on the default
 * Gravatar. Mounted globally alongside the other app-shell-level banners.
 */
const ProfilePhotoFirstLoginNudge: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { user } = useGetProfile();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (
      isAuthenticated &&
      user &&
      !user.hasCustomProfileImage &&
      isProfilePhotoNudgeEligible(TOUCHPOINT)
    ) {
      recordProfilePhotoNudgeShown(TOUCHPOINT);
      setIsOpen(true);
    }
    // Only re-evaluate when auth/user identity changes, not on every profile poll.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.userId]);

  return (
    <ProfilePhotoNudgePrompt
      touchpoint={TOUCHPOINT}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    />
  );
};

export default ProfilePhotoFirstLoginNudge;
